export default function NightShiftIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <rect x="2" y="2" width="60" height="60" rx="14" fill="#13213A" />
      <circle cx="51" cy="13" r="7" fill="#FFE9A8" />
      <circle cx="54" cy="11" r="6" fill="#13213A" />
      <path d="M27 6h7l-4 5h5l-9 9 2-6h-4z" fill="#FFD84D" stroke="#0E1626" strokeWidth="1.2" strokeLinejoin="round" />
      <path d="M30 19v-4" stroke="#2E4A68" strokeWidth="2.5" strokeLinecap="round" />
      <rect x="12" y="19" width="36" height="30" rx="8" fill="#6FA8DC" stroke="#0E1626" strokeWidth="2.5" />
      <circle cx="10" cy="34" r="3.5" fill="#FFD84D" stroke="#0E1626" strokeWidth="1.5" />
      <circle cx="50" cy="34" r="3.5" fill="#FFD84D" stroke="#0E1626" strokeWidth="1.5" />
      <circle cx="22" cy="32" r="6.5" fill="#203048" />
      <circle cx="38" cy="32" r="6.5" fill="#203048" />
      <circle cx="22" cy="32" r="4" fill="#8FF3FF" />
      <circle cx="38" cy="32" r="4" fill="#8FF3FF" />
      <rect x="21" y="41" width="3" height="5" fill="#203048" />
      <rect x="26" y="41" width="3" height="5" fill="#203048" />
      <rect x="31" y="41" width="3" height="5" fill="#203048" />
      <rect x="36" y="41" width="3" height="5" fill="#203048" />
      <rect x="6" y="52" width="52" height="8" rx="3" fill="#2C3A4C" />
      <rect x="10" y="54" width="9" height="4" rx="1.5" fill="#FF8A3D" />
      <rect x="22" y="54" width="9" height="4" rx="1.5" fill="#FFF2A8" />
      <rect x="33" y="54" width="9" height="4" rx="1.5" fill="#4A5468" />
      <rect x="45" y="54" width="9" height="4" rx="1.5" fill="#4A5468" />
    </svg>
  );
}
